module.exports = __webpack_public_path__ + "static/media/rascal.fce4d914.jpg";